import { RefObject, useContext } from 'react';

import { createContext } from 'react';

export const CanvasContainerContext = createContext<RefObject<HTMLDivElement> | null>(null);

export const useCanvasContainer = () => {
    const ctx = useContext(CanvasContainerContext);
    if (!ctx) throw new Error('useCanvasContainer must be used inside a CanvasContainerProvider');
    return ctx;
};
